<template>
    <div>
        <h2 is="sui-header">{{ $t('gateway.cronConfig.title') }}</h2>

        <sui-form-field required>
            <label>{{ $t('gateway.cronConfig.fileLabel') }}:</label>

            <sui-dropdown
                :options="options"
                :placeholder="$t('gateway.cronConfig.title')"
                search
                selection
                required
                v-model="activeGateway.configuration.cronExpression"
            />
        </sui-form-field>

        <sui-divider section />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
    export default {
        name: 'CronConfig',
        computed: {
            ...mapGetters(['activeGateway']),
        },
        data() {
            return {
                current: null,
                options: [{
                    text: this.$t('gateway.cronConfig.never'),
                    value: 'NEVER',
                }, {
                    text: this.$t('gateway.cronConfig.every6hours'),
                    value: 'EVERY_6HOURS'
                }, {
                    text: this.$t('gateway.cronConfig.every12hours'),
                    value: 'EVERY_12HOURS',
                }]
            }
        }
    }
</script>